import {
  CREATETEAMMEMBER,
  GETTEAMMEMBER,
  DELETETEAMMEMBER,
  UPDATETEAMMEMBER,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETTEAMMEMBER:
      return {
        ...state,
        teammemberList: action.payload.data,
      };
    case UPDATETEAMMEMBER:
      return {
        ...state,
        teammemberUpdateStatus: action.payload.success,
      };

    case DELETETEAMMEMBER:
      return {
        ...state,
        teammemberList: state.teammemberList.filter(
          (item) => item.id !== action.memberId,
        ),
        teammemberDeleteStatus: action.payload.success,
      };
    default:
      return state;
  }
}
